
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiration/[workType]",
      function () {
        return require("private-next-pages/inspiration/[workType].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspiration/[workType]"])
      });
    }
  